var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
let ToggleComponent = class ToggleComponent extends GGOBaseComponent {
    static get styles() {
        return [...super.styles, css ``];
    }
    constructor() {
        super();
        this.checked = false;
        this.disabled = false;
    }
    _handleClick(e) {
        e.preventDefault();
        this.dispatchEvent(new CustomEvent('changed', { detail: !this.checked }));
    }
    render() {
        console.log('render toggle', this.checked);
        const id = Math.random().toString(36).substring(8);
        return html `
      <div class="slds-form-element">
        <label class="slds-checkbox_toggle slds-grid">
          <span class="slds-form-element__label slds-m-bottom_none"><slot></slot></span>
          <input
            type="checkbox"
            name="checkbox-toggle-${id}"
            .checked=${this.checked}
            ?disabled=${this.disabled}
            aria-describedby="checkbox-toggle-${id}"
            @click=${this._handleClick}
          />
          <span id="checkbox-toggle-${id}" class="slds-checkbox_faux_container">
            <span class="slds-checkbox_faux"></span>
          </span>
        </label>
      </div>
    `;
    }
};
__decorate([
    property({ type: Boolean })
], ToggleComponent.prototype, "checked", void 0);
__decorate([
    property({ type: Boolean })
], ToggleComponent.prototype, "disabled", void 0);
ToggleComponent = __decorate([
    customElement('ggo-toggle')
], ToggleComponent);
export { ToggleComponent };
